import React, { useState } from 'react'

import {
  getConstanceSettings,
  getUser,
} from '@disco/state-management/selectors/user'
import captureError from '@disco/utils/captureError'
import { redirectToChargebeeCancelPage } from '@disco/utils/chargebee'
import { pushUINotification } from '@disco/utils/notifications'

import { Button, Text } from 'components/ds'

import { useSelector } from 'hooks/use-redux'

import { CancelSubscriptionModal } from './cancel-subscription/CancelSubscriptionModal'

export function SubscribedUserBillingCancelButton({
  cancelSubscriptionModalOpen,
  setCancelSubscriptionModalOpen,
  hasChargebeeScriptLoaded,
}: {
  cancelSubscriptionModalOpen: boolean
  setCancelSubscriptionModalOpen: (open: boolean) => void
  hasChargebeeScriptLoaded: boolean
}) {
  const user = useSelector(getUser)

  const constance = useSelector(getConstanceSettings)

  const [isLoadingCancelPage, setIsLoadingCancelPage] = useState(false)

  const selfServeCancellationRollout =
    constance.SELF_SERVE_CANCELLATION_ROLLOUT ?? false

  return (
    <>
      <Button
        variant="ghost"
        color="red"
        size="3"
        disabled={
          selfServeCancellationRollout ? !hasChargebeeScriptLoaded : false
        }
        loading={isLoadingCancelPage}
        data-testid={
          selfServeCancellationRollout ? undefined : 'cancel-disco-plan-button'
        }
        onClick={async () => {
          if (selfServeCancellationRollout) {
            if (!constance['SUB-735-CHARGEBEE-CANCELLATION']) {
              setCancelSubscriptionModalOpen(true)
              return
            }

            setIsLoadingCancelPage(true)

            try {
              await redirectToChargebeeCancelPage(user)
            } catch (error) {
              pushUINotification({
                message:
                  'Your cancellation could not be completed due to an error. Your subscription is still active. Please contact our support team to finish the cancellation.',
                level: 'error',
              })
              captureError(error, {
                description:
                  'redirectToChargebeeCancelPage error in SubscribedUserBillingCancelButton',
              })
            } finally {
              setIsLoadingCancelPage(false)
            }
          }
        }}
      >
        <Text size="2">Cancel subscription</Text>
      </Button>
      {!constance['SUB-735-CHARGEBEE-CANCELLATION'] && (
        <CancelSubscriptionModal
          open={cancelSubscriptionModalOpen}
          onOpenChange={setCancelSubscriptionModalOpen}
        />
      )}
    </>
  )
}
